/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { classNames } from '#utils/UNSAFE_classNames';
import { tableDragIndicatorStyles } from './themes/Table.css';

/**
 * Props for the TableDragIndicator Component
 */
type TableDragIndicatorProps = {
  isRtl: boolean;
  position?: number;
  height?: number;
};

/**
 * The internal component used to render a drag indicator line in the Table.
 */
export function TableDragIndicator({ position, isRtl, height }: TableDragIndicatorProps) {
  const tableDragIndicatorClasses = classNames([tableDragIndicatorStyles.base]);

  const getDragIndicatorStyle = () => {
    const heightString = height != null ? `height:${height}px;` : '';
    if (position != null) {
      return isRtl
        ? `right:${position}px;cursor:col-resize;${heightString}`
        : `left:${position}px;cursor:col-resize;${heightString}`;
    }
    return `display:none;`;
  };

  return <div class={tableDragIndicatorClasses} style={getDragIndicatorStyle()} />;
}
